module.exports = __webpack_public_path__ + "576f55c34a35e2d1e8d46dc916dd53de.woff";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensansitalic.woff
// module id = 683
// module chunks = 57